import { Breadcrumbs, styled } from "@mui/material";

export const CustomBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
    "& li.MuiBreadcrumbs-separator": {
      margin: 0
    },
  }));
  